import { render } from "./learningPage.vue?vue&type=template&id=6dd30b5a"
import script from "./learningPage.vue?vue&type=script&lang=js"
export * from "./learningPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__